import type { ReactNode } from 'react';

interface Props {
  /** The day's number, in the dot on the rail. */
  number: number;
  /** Something happens that day: teal dot and line; otherwise grey. */
  filled: boolean;
  /** The last day ends the rail. */
  last: boolean;
  /** The line beside the dot: day label, date and whatever the view adds. */
  header: ReactNode;
  children?: ReactNode;
}

/** One day on a vertical timeline — the tickets' chronology and the diary share it. */
export default function TimelineDay({ number, filled, last, header, children }: Props) {
  return (
    <div className="flex gap-0">
      <div className="flex flex-col items-center w-10 shrink-0">
        <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 z-10 text-xs font-bold border-2 ${
          filled
            ? 'bg-teal-500 border-teal-500 text-white'
            : 'bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700 text-slate-400 dark:text-slate-500'
        }`}>
          {number}
        </div>
        {!last && (
          <div className={`w-0.5 flex-1 min-h-[20px] ${filled ? 'bg-teal-200 dark:bg-teal-800' : 'bg-slate-200 dark:bg-slate-800'}`} />
        )}
      </div>

      <div className="flex-1 min-w-0 pb-6">
        <div className="flex items-center gap-2 mb-2 mt-0.5">{header}</div>
        {children}
      </div>
    </div>
  );
}
